/**
 * Affiliates (ADR-084): marketers paid a commission on the orders they bring —
 * through their `?ref=` link or their own coupon — and paid out by hand.
 * Money in halalas; rates in basis points (1000 = 10%).
 */
/** `?ref=` codes: lower case, letters, digits and dashes. */
export const AFFILIATE_CODE_PATTERN = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/;
//# sourceMappingURL=affiliates.js.map